@use '@/styles/_globals' as globals;
@use './lib/slick.min' as *;

$imagePath: '@/styles/../../assets/img';

.image-sec {
    position: relative;
    overflow: hidden;

    .slick-slider {
        height: 100%;
        z-index: 1;
        position: relative;
    }

    .slick-list,
    .slack-track,
    .slick-slide,
    .slick-slide > div,
    .slick-slide img {
        height: 100%;
    }

    .slick-slide {
        overflow: hidden;

        img {
            margin: 0;
        }
    }

    .slick-arrow {
        width: 20px;
        height: 46px;
        z-index: 2;

        @media screen and (max-width: 1000px) {
            display: none !important;
        }

        &:before {
            content: '';
            color: transparent;
        }
    }

    .slick-prev {
        left: 25px;
        background-image: url(globals.$imagePath + '/slider_arrow_left.png');

        &:hover {
            background-image: url(globals.$imagePath + '/slider_arrow_left.png');
        }
        @media (max-width: 700px) {
            left: 0;
        }
    }

    .slick-next {
        right: 25px;
        background-image: url(globals.$imagePath + '/slider_arrow_right.png');

        &:hover {
            background-image: url(globals.$imagePath + '/slider_arrow_right.png');
        }

        @media (max-width: 700px) {
            right: 0;
        }
    }
}
